import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=5bd89bec&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=5bd89bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd89bec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd89bec')) {
      api.createRecord('5bd89bec', component.options)
    } else {
      api.reload('5bd89bec', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=5bd89bec&scoped=true&", function () {
      api.rerender('5bd89bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26dA8BmzAFt9P/JS/comp/GuestBox.vue"
export default component.exports